import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";

const addVehicle = (vehicle, token) => {
  const config = configurationForToken(token);
  return apiClient.post("/admin/vehicle/create", vehicle, config);
};

const updateVehicle = (vehicle, token) => {
  const config = configurationForToken(token);
  const { brand, id, model, patent, chassis_motor, year } = vehicle;
  return apiClient.put(
    "/admin/vehicle/edit",
    { brand, id, model, patent, chassis_motor, year },
    config
  );
};

const deleteVehicle = (vehicleId, token) => {
  const config = configurationForToken(token);
  return apiClient.delete("/admin/vehicle/delete", {
    data: { id: vehicleId },
    ...config,
  });
};

const allVehicles = (token) => {
  const config = configurationForToken(token);
  return apiClient.get("/admin/vehicle/all", config);
};

const deregisterVehicle = (id, token) => {
  const config = configurationForToken(token);
  return apiClient.post(`/admin/vehicle/${id}/deregister`, {}, config);
};

const reregisterVehicle = (id, token) => {
  const config = configurationForToken(token);
  return apiClient.delete(`/admin/vehicle/deregister/${id}`, config);
};

const editDeregister = (newData, id, token) => {
  const config = configurationForToken(token);
  return apiClient.put(`/admin/vehicle/deregister/${id}`, newData, config);
};

export default {
  addVehicle,
  updateVehicle,
  deleteVehicle,
  allVehicles,
  deregisterVehicle,
  reregisterVehicle,
  editDeregister,
};



// WEBPACK FOOTER //
// ./src/Services/VehicleService.js